import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ProjectModel } from '../../models/project.model';

export const ProjectActions = createActionGroup({
  source: 'PROJECT',
  events: {
    'Reset to Initial state': emptyProps(),
    'Get project': props<{ projectId: string }>(),
    'Get project success': props<{ project: ProjectModel.ProjectDocument }>(),
    'Get project fail': props<{ projectId: string }>(),
    'Set selected project': props<{ project: ProjectModel.ProjectDocument | null }>(),
    'Before load projects': props<{ filters: ProjectModel.API.ListProjectsQuery }>(),
    'Load projects': props<{ filters: ProjectModel.API.ListProjectsQuery }>(),
    'Load projects success': props<{
      projects: ProjectModel.ProjectDocument[];
      filters: ProjectModel.API.ListProjectsQuery;
    }>(),
    'Load projects fail': emptyProps(),
    'Do nothing': emptyProps(),
    'Create project': props<{ payload: ProjectModel.API.CreateProjectDto }>(),
    'Create project success': props<{
      project: ProjectModel.ProjectDocument;
    }>(),
    'Create project fail': emptyProps(),
    'Update project': props<{
      projectId: string;
      payload: ProjectModel.API.UpdateProjectDto;
    }>(),
    'Update project success': props<{
      project: ProjectModel.ProjectDocument;
    }>(),
    'Update project fail': emptyProps(),
    'Close project': props<{
      projectId: string;
      payload: ProjectModel.API.CloseProjectDto;
    }>(),
    'Close project success': props<{
      project: ProjectModel.ProjectDocument;
    }>(),
    'Close project fail': props<{ projectId: string }>(),
    'Request delete project': props<{ project: ProjectModel.ProjectDocument }>(),
    'Request delete project cancel': emptyProps(),
    'Delete project': props<{ projectId: string }>(),
    'Delete project success': props<{ projectId: string }>(),
    'Delete project fail': props<{ projectId: string }>(),
  },
});
